import { PERMISSIONS } from '../../constants';
import list from './PotencialFraudList';
import show from './PotencialFraudShow';

export default {
  list,
  show,
  name: 'chains/chainId/potencial-frauds',
  permissions: [PERMISSIONS.POTENCIAL_FRAUD_LIST],
}